export const TIPOS_ADMIN = ["administracao", "administracao_dash"];

export const isAdminTipo = (tipo) => TIPOS_ADMIN.includes(tipo);

export const redirectByTipo = (tipo, navigate) => {
  if (isAdminTipo(tipo)) {
    navigate("/private/adm");
    return;
  }
  if (tipo === "recepcao") {
    navigate("/private/adm/recepcao");
    return;
  }
  navigate("/private");
};

export const isAcessoBloqueado = (response) =>
  response?.status === 403 && response?.data?.acessoBloqueado === true;
